// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + "flickity" + "." + "e05fd84529acb72a07ea" + ".js";
};